import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import cls from './ModalBodyDocumentInfo.module.css';
import { useModalBodyDocumentInfo } from './useModalBodyDocumentInfo';
import { DocumentCheckboxList } from '../../../Blocks/DocumentationBlock/Components/DocumentCheckboxList/DocumentCheckboxList';
import { DashboardEstimate } from '../../../types/dashboardInformation';

interface ModalBodyDocumentInfoProps {
    classes?: string;
    estimates: DashboardEstimate[];
    selectedEstimates: { [key: number]: boolean };
    handleCheckboxClick: (id: number) => void;
}

export const ModalBodyDocumentInfo = ({
    classes,
    estimates,
    selectedEstimates,
    handleCheckboxClick,
}: ModalBodyDocumentInfoProps) => {
    const { t } = useTranslation();
    return (
        <div className={classNames(cls.ModalBodyDocumentInfo, [classes])}>
            <span className={cls.description}>{t('ModalBodyDocumentInfo.return.description')}</span>
            <DocumentCheckboxList
                estimates={estimates}
                selectedEstimates={selectedEstimates}
                handleCheckboxClick={handleCheckboxClick}
            />
        </div>
    );
};
